<template>
	<div class="steeringCommittee" ref="publications">
		<h2 class = 'my-3'>Steering Committee</h2>
		<p>The BICC Steering Committee is composed of the Director and Co-Director of the BICC, the Dean or Vice-Dean of the UNIL FBM faculty, at least two users of the FBM, if possible one from the Basic Sciences Section (SSF) and the other from the Clinical Sciences Section (SSC). It is also composed of the Dean or Vice-Dean of the EPFL SV faculty and at least two users from the EPFL. The Steering Committee is composed of a maximum of 10 members, composed as far as possible of equal shares of both parties. The composition of the committee is proposed by the director and co-director of the Center and is validated by the Deanships of both parties.</p>
		<p>Current members are:</p>

		<p><img src="../../assets/unilogo_small.png"  height="29" width="78"></p>
		<ul>
			<li><strong>Nicolas Guex</strong> (BICC Head)</li>
			<li><strong>J&eacute;r&ocirc;me Goudet</strong> (Vice-Doyen ex-officio Affaires SSF et plateformes)</li>
			<li><strong>Maria Cristina Gambetta</strong> (FBM, SSF  <a href="https://gambettalab.org/" target="_blank">Gambetta Lab<span class="ml-2"><v-icon name="external-link-alt" scale="0.8" /></span></a>)</li>
			<li><strong>Pierre-Yves Bochud</strong> (FBM, SSC <a href="https://www.chuv.ch/fr/min/min-home/le-service-en-bref/nos-collaborateurs/direction-et-equipe-medicale/prof-pierre-yves-bochud" target="_blank">Bochud Lab<span class="ml-2"><v-icon name="external-link-alt" scale="0.8" /></span></a>)</li>
			<li><strong>Anne-Christine Butty</strong> (Coordinator of FBM Research Facilities)</li>
		</ul>

		<p><img src="../../assets/epfllogo_small.png" height="29" width="67"></p>
		<ul>
			<li><strong>Christian Iseli</strong> (BICC co-Head)</li>
			<li><strong>Andy Oates</strong> (Dean, SV)</li>
            <li><strong>Johannes Gr&auml;ff</strong> (SV-BMI <a href="https://www.epfl.ch/labs/graefflab/" target="_blank">Gr&auml;ff Lab<span class="ml-2"><v-icon name="external-link-alt" scale="0.8" /></span></a>)</li>
			<li><strong>Felix Naef</strong> (SV  <a href="https://www.epfl.ch/labs/naef-lab/" target="_blank">Naef Lab<span class="ml-2"><v-icon name="external-link-alt" scale="0.8" /></span></a>)</li>
			<li><strong>Roman Chrast</strong> (Coordinator of SV research facilities)</li>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'steeringCommittee',
}
</script>

<style scoped>

</style>